import { ANIMATION_DURATION } from "components/Message/configs";
import styled from "styled-components";

const FullPageContainer = styled.main`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.secondary};
  min-height: 100vh;
  position: relative;
  transition: padding-bottom ${ANIMATION_DURATION};
`;

export default FullPageContainer;
